import React from 'react'
import Loader from './Loader/Loader';
import { useWindowSize } from '../hooks/useWindowSize'


export default ({ menu, loading, periods }) => {
    
    const { width, height } = useWindowSize() 


    const strokeStyle = () => {
        if (width > 3000) {
            if (menu.length > 10) return { fontSize: `${height * 0.7 / menu.length}px` }
            if (menu.length > 7) return { fontSize: '120px' }
            if (menu.length > 3) return { fontSize: '150px' }
            return { fontSize: '180px', paddingBottom: '40px' }
        } else {
            if (menu.length > 10) return { fontSize: `${height * 0.7 / menu.length}px` }
            if (menu.length > 7) return { fontSize: '60px' }
            if (menu.length > 3) return { fontSize: '75px' }
            return { fontSize: '90px', paddingBottom: '15px' }
        }
    }

    
    const { KKalVisible } = periods.list.find(a => a.xp_Key === periods.currentVisiblePeriod) || {}
    const visibleCalories = !!parseInt(KKalVisible)

    return (
        <main>
            {loading ? <Loader top="50%" left="40%"/> : <div className="wrapper">
                <div className="menu">
                    {menu && menu.length > 0 && menu.map(a => {
                        if (a) {
                            return (
                                <div key={a.xp_Key} className="table-row" style={strokeStyle()}>
                            <div>{a.Name}</div>
                            <div>
                                {a.Exit_period} {a.EdIzm_period}
                            </div>
                            {   
                                visibleCalories &&
                                    <div className='kkal'>
                                        {a.kcal} кКал
                                    </div>
                            }
                        </div>
                            )
                        } 
                    })}
                </div>
            </div>}
        </main>
    );
}
